import subscribe from "./subscribe";
import auth from "./auth";
import patients from "./patients";
import medications from "./medications";
import chat from "./chat";
import reports from "./reports";
import drugs from "./drugs";
import congresses from "./congresses";
import tabs from "./tabs";
import diseases from "./diseases";
import billing from "./billing";
import { insurers } from "./billing/insurers";
import pharmacy from "./pharmacy";

/**
 * Object containing various services.
 * @type {any}
 */
export const services = {
  subscribe,
  auth,
  patients,
  medications,
  chat,
  reports,
  drugs,
  congresses,
  tabs,
  diseases,
  billing,
  insurers,
  pharmacy,
};
